import React, { useRef, useMemo } from "react";
import Config from "@skin_config";
import Helpers from "@common/helpers/helperFunctions";
import { useDispatch } from "react-redux";
import { UpperScreen } from "@common/actions/terminal";
import { useSecondScreenHandler } from "../../hooks/secondScreenHandler";

import './style.scss';
import { getTerminalLanguage } from "@app/dev/helpers/languageByIdOrConfig";

function SecondScreen() {
  const isDualscreen = sessionStorage.getItem("dualscreen");
  const dispatch = useDispatch();
  const terminalLang = getTerminalLanguage();

  const iframeQuery = useMemo(() => {
    if (!Helpers.isSplitScreenAvailable(Config)) return "";

    const authData = JSON.parse(sessionStorage.getItem("authData"));
    const query = new URLSearchParams();

    authData.pid && query.append("pid", authData.pid);
    authData.betshopid && query.append("bid", authData.betshopid);

    query.append("lng", authData.lng || terminalLang);

    Config.iframeURL && query.append("iframeURL", encodeURIComponent(Config.iframeURL));

    return query.toString();
  }, []);

  const iframeRef = useRef();

  useSecondScreenHandler(
    (e) => {
      if (Helpers.isSplitScreenAvailable(Config)) {
        const { current } = iframeRef;
        current?.contentWindow.postMessage(
          JSON.stringify({
            type: "outside",
            ...e.detail,
            command: `${e.detail.command}_PRO`,
          }),
          "*"
        );
      } else if (isDualscreen === "true") {
        dispatch(
          UpperScreen({
            type: e.detail.command,
            id: e.detail.id,
            videoURL: e.detail.url,
            tv_type: e.providerId,
            isNewStatistic: Config.main.isNewStatistic,
          })
        );
      }
    },
    [iframeRef.current]
  );

  return Helpers.isSplitScreenAvailable(Config) ? (
    <iframe ref={iframeRef} className="split-screen-iframe" src={`${Config.splitScreen.url}/?${iframeQuery}`} />
  ) : null;
}

export default SecondScreen;
